import { PlanTemplateType } from "../../templates/generated/template_types";
import type { PlaniraTemplate } from "../../templates/types";
import { ModuleDoneType, ModuleType, PlanType } from "../../templates/types";

export const QuickstartExpensesTemplate: PlaniraTemplate = {
  planType: PlanType.Quickstart,
  type: PlanTemplateType.QuickstartExpenses,
  title: "Split expenses",
  description:
    "Track and divide bills seamlessly, ensuring minimal transactions.",
  longDescription: "",
  emoji: "💰",
  titleHelp: "Weekend trip, party expenses, birthday",

  image: require("../../assets/illustrations/Smiley face-amico.svg"),
  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "N/A",
          isDraggable: false,
          emoji: "💰",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Expense,
          doneType: ModuleDoneType.None,
          title: "Expenses",
          emoji: "💰",
        },
      ],
    },
  ],
};
